





































import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDate } from "@/lib/utility/date-helper";
import { IInvoice } from "@/models/invoice.entity";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: { simpleDate }
})
export default class RefsInvoice extends BaseRef<IInvoice> implements IRefDetail<IInvoice> {
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: IInvoice;

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }
}
